import React from 'react';

import { Box, color, Typography } from '@kis-technologies/kis-ui';
import { MediaTypes } from '../../../types';

interface VideoProps {
  videoType?: string;
}

export const Requirements = (props: VideoProps) => (
  <>
    <Box sx={{ whiteSpace: 'pre-wrap', margin: '16px 0px' }}>
      <Typography fontSize={12} fontWeight={600}>
        Recommended Resolution
      </Typography>
      <Typography fontSize={12}>
        {props.videoType === MediaTypes.ATTRACT_VIDEO
          ? 'Landscape: 1720px by 880px \nPortrait: 880px by 1705px'
          : 'Landscape: 1920px by 1080px \nPortrait: 1080px by 1920px'}
      </Typography>
    </Box>
    <Box sx={{ margin: '16px 0px 32px' }}>
      <Typography fontSize={12} fontWeight={600} color={color.RED}>
        Requirements
      </Typography>
      <Typography fontSize={12}>
        File format must be .mp4 or .mov
        <br />
        Maximum file size allowed is 100MB
      </Typography>
    </Box>
  </>
);
